import apiClient from '../utils/apiService';

export const sophiaAssistantApi = {
  chat: (data) => apiClient.post('/ai/customer-service/chat', data, {
    timeout: 60000,
  }),
};
